export const TYPE_OPTIONS = [
    {
        label: "Standard",
        value: "standard"
    }
];

export const IMPACT_OPTIONS = [
    {
        label: "Low",
        value: "low"
    },
    {
        label: "Medium",
        value: "medium"
    },
    {
        label: "High",
        value: "high"
    },
    {
        label: "None",
        value: "none"
    }
];

export const ATTRIBUTE_OPTIONS = [
    {
        label: "Login",
        value: "login"
    }
];